export const namespaced = true;

export const state = {
  rules: [],

  displayed: [],
  query: null,
};

export const mutations = {
  SET_RULES(state, data) {
    state.rules = data;
  },
  ADD_RULE(state, data) {
    console.log(data);

    state.rules.push(data);
  },
  SET_QUERY(state, query) {
    state.query = query;
    let url = window.location.pathname;
    if (query) {
      url = url + "#" + query;
    }
    history.pushState({}, null, url);
  },
  SET_DISPLAYED(state, displayed) {
    state.displayed = displayed;
  },
  CLEAR_RULES(state) {
    state.rules = [];
    state.displayed = [];
    state.query = null;
    sessionStorage.clear();
  },
};

export const actions = {
  clearRules({ commit }) {
    commit("CLEAR_RULES");
  },
  removeRuleByName({ commit }, name) {
    let rules = state.rules;
    rules = rules.filter((rule) => rule.name !== name);

    commit("SET_RULES", rules);
    sessionStorage.setItem("rules", JSON.stringify(rules));
  },
  addRule({ commit, rootState }, rule) {
    console.log(rule);
    let name = rule.updated_by;
    console.log(name);
    if (rule.updated_by != null) {
      console.log(rootState);
      rootState.users.users.forEach((user) => {
        if (user.name === name) {
          rule.updated_by = user.id;
        }
      });
    }
    commit("ADD_RULE", rule);
    sessionStorage.setItem("rules", JSON.stringify(state.rules));
  },
  applyRules({ commit }, rules) {
    commit("SET_RULES", rules);
    sessionStorage.setItem("rules", JSON.stringify(rules));
  },
  setPrevRules({ commit }, rules) {
    commit("SET_RULES", rules);
  },
};

export const getters = {
  rules: (state) => state.rules,
};
